export class SearchInfo {
    public searchToken: string = '';
    public matchCase: boolean = false;
    public matchWholeWord: boolean = false;
    public useRegularExpressions: boolean = false;
}
